import readXlsxFile, { Schema } from "read-excel-file"
import { BaseWBRecodeItemType } from "./types"
import {
  BASE_RECODE_WB_SCHEMA_EXCEL,
  BASE_RECODE_WB_SCHEMA_JSON,
} from "../../utils/const"
import writeXlsxFile, { Schema as WriteSchema } from "write-excel-file"
export const parseWbRecode = async <T extends BaseWBRecodeItemType>(
  file: File,
  additionalFields: string[],
): Promise<T[]> => {
  const schema: Schema = createJsonShchemaByFields(additionalFields)
  const dataFromXslx = await readXlsxFile<T>(file, {
    schema,
  })
  return dataFromXslx.rows
}

const createJsonShchemaByFields = (fields: string[]): Schema => {
  const schema: Schema = { ...BASE_RECODE_WB_SCHEMA_JSON }
  fields.forEach((field) => {
    schema[field] = { prop: field, type: String, required: true }
  })
  return schema
}

export const formRecodeFile = <T extends BaseWBRecodeItemType>(
  rows: T[],
  additionalFields: string[],
  fileName: string,
) => {
  writeXlsxFile(rows, {
    schema: createXlsxShchemaByFields(additionalFields),
    fileName: `${fileName}.xlsx` || "перекодировка.xlsx",
  })
}

const createXlsxShchemaByFields = <T>(fields: string[]): WriteSchema<T> => {
  const additionalSchema = fields.map((field) => ({
    column: field,
    value: (item: any) => item[field],
  }))

  return [...BASE_RECODE_WB_SCHEMA_EXCEL, ...additionalSchema]
}
